import { IApplicationState } from 'setup/store'

export const selectCarousels = (state: IApplicationState) => state.slider.data.carousels

export const selectCarouselsLoading = (state: IApplicationState) => state.slider.communications.loadCarousels
